import { Flex } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import { isMemberRole } from 'src/role';

import { useGetAllProducts } from 'src/graphql/useGetAllProducts';
import EmptyModuleList from './EmptyModuleList';
import ProductItemDesktop from './ProductItemDesktop';
import CMPModule from './ProductItemCMP';
import ProductItemWeb from './ProductItemWeb';
import { TableSkeleton } from './TableSkeleton';

interface ModuleListProps { }

const ModuleList: FunctionComponent<ModuleListProps> = () => {
    const { t } = useTranslation();
    const { user: contextUser } = useContext(AppContext);
    const user = contextUser!;
    const { data } = useGetAllProducts(user!.userId);
    const isMember = isMemberRole(user.role);

    if (isMember && user.modules.length === 0) {
        return (<EmptyModuleList />);
    }

    if (!data) {
        return null;
    }

    const otherGmgAppsToShow = isMember
        ? []
        : data.filter(product => !user.modules.includes(product.productLine) && product.productLine !== 'Optimize');

    return (
        <Flex flexDirection='column' gap='16px' width='100%'>
            <TableSkeleton title={t('UserProfile.table_title', 'My Apps')}>
                {isMember ? null : <CMPModule />}
                {user.modules.map((productLine) => {
                    const product = data.find(p => p.productLine === productLine);
                    if (!product) {
                        console.error(`It is a safety check and logging should not happen. Product with productLine : ${productLine} not found`);
                        return null;
                    }

                    return product.kind === 'desktop'
                        ? <ProductItemDesktop key={product.productLine} product={product} />
                        : <ProductItemWeb key={product.productLine} product={product} />;
                })}
            </TableSkeleton>
            <TableSkeleton title={t('UserProfile.other_apps_title', 'Other GMG Apps')}>
                {otherGmgAppsToShow.map((product) => product.kind === 'desktop'
                    ? <ProductItemDesktop key={product.productLine} product={product} />
                    : <ProductItemWeb key={product.productLine} product={product} />)
                }
            </TableSkeleton>

        </Flex>
    );
};

export default ModuleList;
